import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ArAgingReport, CustomerStatement } from '../interfaces/sales/salesReport.interface';

export const SalesReportService = {
  aging: async (institutionId: string): Promise<ArAgingReport> =>
    (await axios.get(ENDPOINTS.SALES_REPORT.AGING(institutionId))).data,
  statement: async (customerId: string, from: string, to: string): Promise<CustomerStatement> =>
    (await axios.get(ENDPOINTS.SALES_REPORT.STATEMENT(customerId, from, to))).data,
};
